import { render } from "./LoginForgot.vue?vue&type=template&id=27549f3c&scoped=true"
import script from "./LoginForgot.vue?vue&type=script&lang=js"
export * from "./LoginForgot.vue?vue&type=script&lang=js"

import "./LoginForgot.vue?vue&type=style&index=0&id=27549f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27549f3c"]])

export default __exports__